// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles-module--headline--1_g3l","logoRow":"styles-module--logoRow--1R8aT","logo":"styles-module--logo--tjmsK"};